import { render } from "./my-dialog.vue?vue&type=template&id=253bed58"
import script from "./my-dialog.vue?vue&type=script&lang=js"
export * from "./my-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__